import React from "react";
import { useListContext } from "react-admin";
import { ListItemText, MenuItem } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import { MobileListMenu } from "./MobileListMenu";

export type MobileListSortOption = {
  field: string;
  order: "ASC" | "DESC";
  label: string;
};

type Props = {
  options: readonly MobileListSortOption[];
};

export const MobileListSort = ({ options }: Props) => {
  const { sort, setSort } = useListContext();

  const handleSelect = (field: string, order: "ASC" | "DESC", closeMenu: () => void) => {
    setSort({ field, order });
    closeMenu();
  };

  return (
    <MobileListMenu
      buttonIcon={<SortIcon />}
      buttonLabel="並び替え"
      menuId="mobile-list-sort-menu"
      renderMenuItems={(closeMenu) =>
        options.map((option) => (
          <MenuItem
            key={`${option.field}-${option.order}`}
            onClick={() => handleSelect(option.field, option.order, closeMenu)}
            selected={sort.field === option.field && sort.order === option.order}
          >
            <ListItemText>{option.label}</ListItemText>
          </MenuItem>
        ))
      }
    />
  );
};
